/* STEP 11b Part 2 · lane P2A (owner card 31-Oct-2026 12:44 KSA, the Mars finds) — EN + AR of
   F1 the client's voucher lines to mark as the correction (treatment (d), RestatementClientVoucherLines),
   F2 "Figures the trial balance does not hold" on the statement of cash flows (IFRSCashFlowTbInputs),
   F5 the prior year's OCI closed into its reserve on Opening balances. No standard paragraph is quoted. */
const I18N_S11B2 = {
  en: {
    s11b2: {
      f1: {
        showLines: "Show the voucher's lines",
        useSuggested: "Mark the {n} lines that match this entry",
        marked: "{n} of {m} lines marked as the correction — the other lines stay current-year activity",
        wholeVoucher: "No line marked: the whole voucher is the correction",
        notFound: "Voucher {v} is not in the client's current-year ledger.",
        colCorrection: "Correction",
        colNarration: "Narration",
        plLine: "profit or loss",
        rule: "Mark the lines that correct the prior year. The marked lines must equal this entry's effect on the prior-year closing balances, account by account; the lines not marked (for example this year's depreciation booked in the same voucher) stay current-year activity.",
      },
      f2: {
        title: "Figures the trial balance does not hold",
        hint: "This year's data is a trial balance: it shows closing balances, not the vouchers behind them. Enter the figures below from the client's records (0 if none).",
        dividends_paid: "Dividends paid in the year",
        ppe_disposal_proceeds: "Proceeds from disposal of PPE",
        ppe_disposal_cost: "Cost of PPE disposed of",
        save: "Save figures",
        saved: "Figures saved — the cash flow is recalculated",
        derivedTitle: "Read from the trial balance:",
        derived: {
          fvoci_oci: "FVOCI fair-value change (not cash)",
          eosb_oci_tax: "deferred tax on the EOSB remeasurement (not the obligation)",
          assoc_share: "share of the associate's profit (not cash)",
          receivables_written_off: "receivables written off",
        },
      },
      f5: {
        ociClosedRow: "incl. prior-year other comprehensive income",
      },
    },
  },
  ar: {
    s11b2: {
      f1: {
        showLines: "عرض أسطر القيد",
        useSuggested: "تحديد الأسطر الـ {n} المطابقة لهذا القيد",
        marked: "تم تحديد {n} من {m} سطرًا كتصحيح — تبقى الأسطر الأخرى نشاطًا للسنة الحالية",
        wholeVoucher: "لم يُحدَّد أي سطر: القيد كله هو التصحيح",
        notFound: "القيد {v} غير موجود في دفتر الأستاذ للسنة الحالية لدى العميل.",
        colCorrection: "تصحيح",
        colNarration: "البيان",
        plLine: "ربح أو خسارة",
        rule: "حدد الأسطر التي تصحح السنة السابقة. يجب أن تساوي الأسطر المحددة أثر هذا القيد على الأرصدة الختامية للسنة السابقة، حسابًا بحساب؛ وتبقى الأسطر غير المحددة (مثل استهلاك هذه السنة المسجل في القيد نفسه) نشاطًا للسنة الحالية.",
      },
      f2: {
        title: "أرقام لا يتضمنها ميزان المراجعة",
        hint: "بيانات هذه السنة ميزان مراجعة: يعرض الأرصدة الختامية لا القيود التي تقف خلفها. أدخل الأرقام أدناه من سجلات العميل (0 إن لم توجد).",
        dividends_paid: "توزيعات الأرباح المدفوعة خلال السنة",
        ppe_disposal_proceeds: "متحصلات استبعاد الممتلكات والآلات والمعدات",
        ppe_disposal_cost: "تكلفة الممتلكات والآلات والمعدات المستبعدة",
        save: "حفظ الأرقام",
        saved: "تم حفظ الأرقام — أعيد احتساب قائمة التدفقات النقدية",
        derivedTitle: "مأخوذ من ميزان المراجعة:",
        derived: {
          fvoci_oci: "تغير القيمة العادلة للاستثمارات من خلال الدخل الشامل الآخر (غير نقدي)",
          eosb_oci_tax: "الضريبة المؤجلة على إعادة قياس مكافأة نهاية الخدمة (ليست على الالتزام)",
          assoc_share: "الحصة في ربح الشركة الزميلة (غير نقدية)",
          receivables_written_off: "الذمم المدينة المشطوبة",
        },
      },
      f5: {
        ociClosedRow: "يشمل الدخل الشامل الآخر للسنة السابقة",
      },
    },
  },
};

export default I18N_S11B2;
